import MarkdownRenderer from './MarkdownRenderer';

interface StreamingTextProps {
  content: string;
}

export default function StreamingText({ content }: StreamingTextProps) {
  return (
    <div className="relative">
      <MarkdownRenderer content={content} />
      <span className="inline-block w-2 h-4 ml-0.5 bg-primary animate-pulse rounded-sm" />
    </div>
  );
}
